import axios from 'axios'
import { useEffect, useState } from 'react'
import {
  appInstallationId,
  appVersion,
  commonHeadersWeb,
  getApiServerUrlObject,
  platformWeb,
} from 'src/consumer/services'

export const clinicApiURL = getApiServerUrlObject().url

/**
 * Get the main language code (e.g., "en" from "en-GB")
 * Always returns the main code, not the localization variant
 */
export function getMainLanguageCode() {
  const languageCode = sessionStorage.getItem('languageCode')
  if (!languageCode) {
    return (navigator?.language || navigator?.userLanguage || 'en').split('-')[0]
  }
  // Extract main code (before hyphen) if it's a locale variant
  return languageCode.split('-')[0]
}

/**
 * Get country code from localStorage with fallback to "in" (India)
 * Never returns null or undefined - always returns a valid country code
 */
export function getCountryCode() {
  const countryCode = localStorage.getItem('countryCode')
  return countryCode || 'in'
}

export const commonHeadersCPWeb = {
  'ef-app-version': appVersion,
  'ef-app-platform': platformWeb,
  'ef-app-package': 'com.aumhum.web',
  'ef-app-installation-id': appInstallationId,
  'ef-device-model': 'iPad11,6',
  'ef-device-os-version': '16',
  'ef-device-manufacturer': 'apple',
  'ef-session-id': sessionStorage.getItem('sessionId'),
  'ef-user-city': 'moscow',
  'ef-device-os-language': (navigator?.language || navigator?.userLanguage).split('-')[0],
}

export async function getCPDataWithoutParams(url) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.get(`${clinicApiURL}${url}`, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function postCPDataWithoutParams(url, data) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    // const os = `${platform.os.family}`.toLowerCase()
    const res = await axios.post(`${clinicApiURL}${url}`, data, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getCPData(url) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.get(
      `${clinicApiURL}${url}?languageCode=${mainLanguageCode}&platform=${platformWeb}&countryCode=${countryCode}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': countryCode,
          'ef-app-language': mainLanguageCode,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getCPDataWithParams(url, apiParams) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.get(`${clinicApiURL}${url}`, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
      params: {
        languageCode: mainLanguageCode,
        platform: platformWeb,
        countryCode: countryCode,
        ...apiParams,
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
export async function postCPData(url, data) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    // const os = `${platform.os.family}`.toLowerCase()
    const res = await axios.post(
      `${clinicApiURL}${url}?languageCode=${mainLanguageCode}&platform=${platformWeb}&countryCode=${countryCode}`,
      data,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': countryCode,
          'ef-app-language': mainLanguageCode,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function patchCPDataWithParams(url, data, params) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    // const os = `${platform.os.family}`.toLowerCase()
    const res = await axios.patch(
      `${clinicApiURL}${url}?languageCode=${mainLanguageCode}&platform=${platformWeb}&countryCode=${countryCode}`,
      data,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': countryCode,
          'ef-app-language': mainLanguageCode,
        },
        params: params,
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
export async function postCPDataWithParams(url, data, params = {}) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    // const os = `${platform.os.family}`.toLowerCase()
    const res = await axios.post(
      `${clinicApiURL}${url}?languageCode=${mainLanguageCode}&platform=${platformWeb}&countryCode=${countryCode}`,
      data,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': countryCode,
          'ef-app-language': mainLanguageCode,
        },
        params: params,
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const useFetchCP = (path, customParams = '', platformType) => {
  const [state, setState] = useState({ loading: true, data: null, error: null })

  const [countryCode, setCountryCode] = useState(localStorage.getItem('countryCode'))

  useEffect(() => {
    function handleChangeStorage() {
      setCountryCode(localStorage.getItem('countryCode'))
    }
    window.addEventListener('storage', handleChangeStorage)
    return () => window.removeEventListener('storage', handleChangeStorage)
  }, [])

  const mainLanguageCode = getMainLanguageCode()
  const token = localStorage.getItem('token')

  useEffect(() => {
    setState({ loading: true, data: null, error: null })

    // Use countryCode from state, or fallback to localStorage, or default to 'in' (India)
    // This allows API calls to proceed even if location hasn't been determined yet
    const effectiveCountryCode = countryCode || localStorage.getItem('countryCode') || 'in'
    const paramsWeb = `languageCode=${mainLanguageCode}&platform=${platformWeb}&countryCode=${effectiveCountryCode?.toLowerCase() || 'in'}`

    let params = paramsWeb

    axios
      .get(`${clinicApiURL}${path}?${params}${customParams}`, {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersCPWeb,
          'ef-user-country-code': effectiveCountryCode?.toLowerCase() || 'in',
          'ef-app-language': mainLanguageCode,
        },
      })
      .then((res) => {
        setState({ data: res.data, loading: false, error: null })
      })
      .catch((error) => {
        setState({ data: null, loading: false, error: error })
      })
  }, [path, customParams, token, countryCode, mainLanguageCode])
  return state
}

export async function putCPDataWithoutParams(url, data) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.put(`${clinicApiURL}${url}`, data, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersCPWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': mainLanguageCode,
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function putCPDataWithParams(url, data, params = {}) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  const mainLanguageCode = getMainLanguageCode()
  try {
    const res = await axios.put(
      `${clinicApiURL}${url}?languageCode=${mainLanguageCode}&platform=${platformWeb}&countryCode=${countryCode}`,
      data,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': countryCode,
          'ef-app-language': mainLanguageCode,
        },
        params: params,
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
